<template>
  <router-view />
</template>

<script setup>
// This component has no script logic. It's just a container.
</script>